// Constants
import constants from '../constants'

// Logo Images
import { diasensImgUrls } from './diasens-constants'

// Signup Components
import FullName from '../components/Signup/FullName'
import DoctorLocation from '../containers/AnayaCare/Components/DoctorLocation'

export const DIASENS_CONFIG = {
  id: constants.CARE_PROGRAM_TYPE.DIASENS,
  name: 'DiaSens CGM Program',
  drug_name: 'DiaSens',
  campaign_link: `${process.env.REACT_APP_FE_URL}/onboarding`,
  medical_condition_group_id: null,
  upload_report_type: null,
  onboarding_steps: [
    {
      name: 'name',
      hideButton: true,
      Component: FullName,
      title: 'Enter your name',
      subtitle: 'We will refer to you by this name in the application.',
      hideImage: true,
    },
    {
      name: 'address',
      hideButton: true,
      Component: DoctorLocation,
      title: 'Your location',
      subtitle: 'We need your location to provide better service.',
      hideImage: true,
      canSkip: true,
    },
  ],
  // Success page configuration
  success_image: diasensImgUrls.successImage,
  success_image_width: '100%',
  success_title: 'Registration completed successfully',
  showMetabolicScore: false,
  logoWhite: diasensImgUrls.logoWhite,
  partnerName: 'DiaSens',
  success_message: () => (
    <>
      <b>GoodFlip</b> in partnership with
      <b> DiaSens</b> <br /> Your trusted health partner.
    </>
  ),
}
